import styled from "styled-components";
import { colors } from "../../../../theme/color";
import fipayFonts from "../../../../theme/index";

export const AccountSettingMain = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-shadow: 0px 4px 4px 0px #eaeaea40;
  height: auto;
`;

export const AccountSettingMainHeader = styled.div`
  padding: 20px;
  width: 96%;
  display: flex;
  border-bottom: 1px solid #e8eaed;
`;

export const AccountSettingHeaderText = styled.span`
  font-weight: 500;
  font-size: 18px;
  color: ${colors.NAVYBLUE};
`;

export const AccountSettingBody = styled.div`
  display: flex;
  // grid-template-columns: 50% 50%;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;

  @media screen and (max-width: 430px) {
    display: flex;
    flex-direction: column;
    width: 90%;
    margin-left: 10px;
  }

  @media screen and (max-width: 390px) {
    display: flex;
    flex-direction: column;
    width: 90%;
    margin-left: 10px;
  }
`;

export const TwoAuthTitleHead = styled.div`
  margin-bottom: 200px;
  padding: 0;
  width: 30%;
  padding-left: 2%;
  padding-right: 10%;

  @media screen and (max-width: 430px) {
    margin-bottom: 10px;
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    margin-bottom: 10px;
    width: 90%;
  }
`;

export const AccountSettinsss = styled.div`
  display: flex;
  padding-bottom: 20px;

  @media screen and (max-width: 430px) {
    display: flex;
    flex-direction: column;
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    display: flex;
    flex-direction: column;
    width: 90%;
  }
`;

export const TwoAuthMainTitle = styled.h5`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.BLACK};
`;

export const TwoAuthSubTitle = styled.h5`
  color: #868686;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin: 0;
  padding: 0;
  letter-spacing: 2%;
  width: 90%;
`;

export const AccountSecSection = styled.div`
  margin: 0 auto;
  padding: 0;
  width: 60%;
  margin: 0px 0px 30px 30px;

  @media screen and (max-width: 430px) {
    display: flex;
    flex-direction: column;
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    display: flex;
    flex-direction: column;
    width: 90%;
  }
`;

export const AccountSecSectionTitle = styled.h5`
  font-size: 14px;
  font-weight: 500;
  color: #0e0e0e;
  margin: 20px 10px;
`;
export const Status = styled.span`
  border: 1px solid #c3e6c0;
  background-color: #c3e6c0;
  color: #4bb543;
  padding: 4px 6px;
  border-radius: 16px;
  font-size: 12px;
`;
export const TitleWrap = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;

export const AccountSecSectionSubTitle = styled.h6`
  font-size: 14px;
  font-weight: 500;
  color: #868686;
  margin: 10px;
`;

export const AccountSecSectionActivate = styled.span<{ $deactivate?: boolean }>`
  font-size: 15px;
  font-weight: 400;
  color: ${({ $deactivate }) => ($deactivate ? "#B00020" : "#00A603")};
  margin: 5px 10px;
  text-align: center;
  cursor: pointer;
`;

export const AccountSecSectionButtoCon = styled.span`
  display: flex;
  justify-content: flex-end;
  width: 95%;
  padding-top: 50px;
`;

export const AccountSectButton = styled.div`
width: 20%;
padding-right: 15px;

@media screen (max-width: 412px) {
  width:70%
  border: 2px solid red;
}
`;

export const AccountSectButton1 = styled.div`
  width: 30%;
`;

export const TwoFactAuthPhoneBox = styled.span`
  width: 90%;
  padding-left: 10px;
  color: ${colors.BLACK};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const TwoFactAuthPhoneContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 15px;
  padding-top: 4px;
`;

export const Label = styled.label`
  padding-left: 17px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const TwoFactAuthSmallInput = styled.input`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  width: 10%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  margin-left: 1px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const TwoFactAuthLargeInput = styled.input`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  margin-left: 8px;
  width: 76%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  -moz-appearance: textfield;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;
